var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "countries-latLng-components-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _vm.currentRow
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title: _vm.currentRow.label + " 經緯度對應設定",
                visible: _vm.dialogVisible,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      { attrs: { inline: true, size: "mini" } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.addPosition },
                              },
                              [_vm._v("新增")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._l(_vm.positionList, function (item, index) {
                      return _c(
                        "el-form",
                        { key: index, attrs: { inline: true, size: "mini" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", size: "mini" } },
                            [_c("el-tag", [_vm._v(_vm._s(index + 1))])],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "區域", size: "mini" } },
                            [
                              item.regions
                                ? _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        "value-key": "key",
                                        placeholder: "區域",
                                        size: "mini",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.selectedRegion(item)
                                        },
                                      },
                                      model: {
                                        value: item.region,
                                        callback: function ($$v) {
                                          _vm.$set(item, "region", $$v)
                                        },
                                        expression: "item.region",
                                      },
                                    },
                                    _vm._l(item.regions, function (c, ind) {
                                      return _c("el-option", {
                                        key: ind,
                                        attrs: { label: c.val, value: c.key },
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "國家", size: "mini" } },
                            [
                              item.countries
                                ? _c(
                                    "el-select",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: item.countriesLoading,
                                          expression: "item.countriesLoading",
                                        },
                                      ],
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        filterable: "",
                                        placeholder: "國家",
                                        "value-key": "code",
                                        size: "mini",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.selectedCountry(item)
                                        },
                                      },
                                      model: {
                                        value: item.country,
                                        callback: function ($$v) {
                                          _vm.$set(item, "country", $$v)
                                        },
                                        expression: "item.country",
                                      },
                                    },
                                    _vm._l(item.countries, function (c, ind) {
                                      return _c("el-option", {
                                        key: ind,
                                        attrs: { label: c.chtName, value: c },
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "城市", size: "mini" } },
                            [
                              item.cities
                                ? _c(
                                    "el-select",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value:
                                            item.countriesLoading ||
                                            item.citiesLoading,
                                          expression:
                                            "item.countriesLoading || item.citiesLoading",
                                        },
                                      ],
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        clearable: "",
                                        filterable: "",
                                        placeholder: "城市",
                                        "value-key": "code",
                                        size: "mini",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.selectedCity(item)
                                        },
                                      },
                                      model: {
                                        value: item.city,
                                        callback: function ($$v) {
                                          _vm.$set(item, "city", $$v)
                                        },
                                        expression: "item.city",
                                      },
                                    },
                                    _vm._l(item.cities, function (c, ind) {
                                      return _c("el-option", {
                                        key: ind,
                                        attrs: { label: c.chtName, value: c },
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "經緯度(lng,lat)" } },
                            [
                              _c(
                                "el-col",
                                { staticClass: "line", attrs: { span: 12 } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "經度(lng)" },
                                    model: {
                                      value: item.lng,
                                      callback: function ($$v) {
                                        _vm.$set(item, "lng", $$v)
                                      },
                                      expression: "item.lng",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { staticClass: "line", attrs: { span: 12 } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "緯度(lat)" },
                                    model: {
                                      value: item.lat,
                                      callback: function ($$v) {
                                        _vm.$set(item, "lat", $$v)
                                      },
                                      expression: "item.lat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deletePosition(item)
                                    },
                                  },
                                },
                                [_vm._v("刪除")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-position",
                                    type: "success",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.googleMap(item)
                                    },
                                  },
                                },
                                [_vm._v("查看Google地圖")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.savePosition },
                    },
                    [_vm._v("確 定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentRow
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title: _vm.currentRow.label + " 貨幣設定",
                visible: _vm.dialogCurrencyVisible,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogCurrencyVisible = $event
                },
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      { attrs: { inline: true, size: "mini" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "貨幣", size: "mini" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "currency-select",
                                staticStyle: { width: "500px" },
                                attrs: {
                                  multiple: "",
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "貨幣",
                                  "value-key": "id",
                                  size: "mini",
                                },
                                model: {
                                  value: _vm.currentRow.currenciesCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.currentRow,
                                      "currenciesCode",
                                      $$v
                                    )
                                  },
                                  expression: "currentRow.currenciesCode",
                                },
                              },
                              _vm._l(_vm.currencyOptionList, function (c, ind) {
                                return _c("el-option", {
                                  key: ind,
                                  attrs: {
                                    label:
                                      c.currencyCode + "-" + c.currencyName,
                                    value: c.currencyCode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveCurrencies },
                    },
                    [_vm._v("確 定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.dialogCurrencyVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", {
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          size: "mini",
                          loading: _vm.listLoading,
                          type: "success",
                          icon: "el-icon-refresh-left",
                          circle: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.refresh()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                "row-style": _vm.rowStyle,
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
                "row-key": "id",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
              },
            },
            [
              _vm._v(" > "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "區域名稱",
                  width: "500",
                  prop: "label",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.label))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "經緯度設定", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.setPosition(scope.row)
                              },
                            },
                          },
                          [_vm._v("設定")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "貨幣設定", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.setCurrency(scope.row)
                              },
                            },
                          },
                          [_vm._v("設定")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }